export class HrOrganizationHeaderKey {
    private static readonly keyPrefix = 'hrOrganizationHeader';
    public static addTitle = `${HrOrganizationHeaderKey.keyPrefix}.addTitle`;
    public static editTitle = `${HrOrganizationHeaderKey.keyPrefix}.editTitle`;
    public static organizationHeader = `${HrOrganizationHeaderKey.keyPrefix}.organizationHeader`;
    public static confirmButton = `${HrOrganizationHeaderKey.keyPrefix}.confirmButton`;
    public static id = `${HrOrganizationHeaderKey.keyPrefix}.id`;
    public static parentId = `${HrOrganizationHeaderKey.keyPrefix}.parentId`;
    public static organizationVersion = `${HrOrganizationHeaderKey.keyPrefix}.organizationVersion`;
    public static versionName = `${HrOrganizationHeaderKey.keyPrefix}.versionName`;
    public static beginDate = `${HrOrganizationHeaderKey.keyPrefix}.beginDate`;
    public static endDate = `${HrOrganizationHeaderKey.keyPrefix}.endDate`;
    public static description = `${HrOrganizationHeaderKey.keyPrefix}.description`;
    public static attachmentId = `${HrOrganizationHeaderKey.keyPrefix}.attachmentId`;
    public static state = `${HrOrganizationHeaderKey.keyPrefix}.state`;
    public static isActive = `${HrOrganizationHeaderKey.keyPrefix}.isActive`;
    public static isApproved = `${HrOrganizationHeaderKey.keyPrefix}.isApproved`;
    public static approverName = `${HrOrganizationHeaderKey.keyPrefix}.approverName`;
    public static approvementDate = `${HrOrganizationHeaderKey.keyPrefix}.approvementDate`;
    public static pageHeader = `${HrOrganizationHeaderKey.keyPrefix}.pageHeader`;
    public static enumActivePassive = `${HrOrganizationHeaderKey.keyPrefix}.enumActivePassive`;
    public static enumConfirm = `${HrOrganizationHeaderKey.keyPrefix}.enumConfirm`;
    public static listTitle = `${HrOrganizationHeaderKey.keyPrefix}.listTitle`;
    public static publishButton = `${HrOrganizationHeaderKey.keyPrefix}.publishButton`;

}
